// D:\directiveai-react\frontend\src\components\home\HomeInput\components\CustomizeButton.jsx

import React from 'react';
import PropTypes from 'prop-types';
import { useTheme, Box } from '@mui/material';
import { Wand2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {
  PromptCardItem,
  PromptIconWrapper,
  PromptText
} from '../HomeInputStyles';

const CustomizeButton = ({ onClick }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
      <PromptCardItem 
        onClick={onClick} 
        sx={{ 
          marginTop: '16px',
          width: 'auto',
          display: 'inline-flex',
          paddingLeft: '12px',
          paddingRight: '16px',
          margin: '0 auto'
        }}
      >
        <PromptIconWrapper>
          <Wand2
            size={16}
            color={
              theme.palette.actualMode === 'wallpaper'
                ? '#FFFFFF'
                : (theme.palette.mode === 'dark' ? '#0385FF' : '#007BFE')
            }
          />
        </PromptIconWrapper>
        <PromptText sx={{
          color: theme.palette.actualMode === 'wallpaper' ? '#FFFFFF' : undefined
        }}>
          {t('homeInput.customize')}
        </PromptText>
      </PromptCardItem>
    </Box>
  );
};

CustomizeButton.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default React.memo(CustomizeButton);